import React from "react";
import { Card, Row, Col, Typography } from "antd";
import {
    AreaChart,
    Area,
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const { Title } = Typography;

// Mock data for Employees' Effective Work Hours
const workHoursData = [
    { date: "Oct 30", hours: 10 },
    { date: "Oct 31", hours: 7 },
    { date: "Nov 01", hours: 12 },
    { date: "Nov 02", hours: 8 },
    { date: "Nov 03", hours: 10 },
    { date: "Nov 04", hours: 2 },
    { date: "Nov 05", hours: 0 },
];

// Mock data for Break Taken by Employees
const breakDurationData = [
    { month: "Jan", duration: 2 },
    { month: "Feb", duration: 8 },
    { month: "Mar", duration: 6 },
    { month: "Apr", duration: 4 },
    { month: "May", duration: 7 },
    { month: "Jun", duration: 9 },
];

const EmployeeMetricsChart: React.FC = () => {
    return (
        <Row gutter={[16, 16]} style={{ margin: 24 }}>
            {/* Left Chart */}
            <Col xs={24} md={12}>
                <Card>
                    <Title level={5}>Employees' Effective Work Hours</Title>
                    <ResponsiveContainer width="100%" height={250}>
                        <AreaChart
                            data={workHoursData}
                            margin={{ top: 20, right: 20, left: 0, bottom: 0 }}
                        >
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Area
                                type="monotone"
                                dataKey="hours"
                                stroke="#82ca9d"
                                fill="#b3e5fc"
                            />
                        </AreaChart>
                    </ResponsiveContainer>
                </Card>
            </Col>

            {/* Right Chart */}
            <Col xs={24} md={12}>
                <Card>
                    <Title level={5}>Break Taken by Employees</Title>
                    <ResponsiveContainer width="100%" height={250}>
                        <LineChart
                            data={breakDurationData}
                            margin={{ top: 20, right: 20, left: 0, bottom: 0 }}
                        >
                            <XAxis dataKey="month" />
                            <YAxis />
                            <Tooltip />
                            <Line
                                type="monotone"
                                dataKey="duration"
                                stroke="#8884d8"
                                fill="#d1c4e9"
                                strokeWidth={2}
                            />
                            <Area
                                type="monotone"
                                dataKey="duration"
                                fill="#d1c4e9"
                                stroke="none"
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </Card>
            </Col>
        </Row>
    );
};

export default EmployeeMetricsChart;
